<template>
    <div class="base">
            <div class="name"  v-if="user.roleId==1" style="">
                <span class="u-line-1">您好！{{user.realName}} </span>
                <img src="@/assets/img/member3.png" alt="">
            </div>
            <div class="name" v-else-if="user.roleId==2"  style="color:#269A99">
                <span class="u-line-1">您好！{{user.realName}} </span>
                <img src="@/assets/img/member2.png" alt="" >
            </div>
            <div class="name" v-else style="color:#E8684A">
                <span class="u-line-1">您好！{{user.realName}} </span>
                <img src="@/assets/img/member1.png" alt="">
            </div>
            <div class="happy">欢迎使用e博视-综合智慧能源管理平台！</div>
            <div class="title">基本信息</div>
            <div class="item">
                <div class="felx">
                    <span class="uname">头像</span>
                    <span class="cont">
                        <img :src="user.img" alt="">
                    </span>
                </div>
                    
                <el-upload
                    class="avatar-uploader"
                    action=""
                    :show-file-list="false"
                    :before-upload="beforeAvatarUpload"
                  >
                    <span class="btn">上传</span>
                </el-upload>
            </div>
            <el-form :model="ruleFormName" label-position="left" :rules="rules" ref="rulesName" label-width="100px" class="ruleForm">
                <el-form-item label="姓名" prop="realName">
                    <span v-if="!showName">{{ruleFormName.realName}}</span>
                    <el-input type="text" v-model="ruleFormName.realName" placeholder="输入姓名" v-else></el-input>
                    <span class="btn" @click="showName=true" v-if="!showName">修改姓名</span>
                    <span class="btn" @click="submitFormName('rulesName')" v-else>保存</span>
                </el-form-item>
            </el-form>
            <!-- <div class="item">
                <div class="felx">
                    <span class="uname">姓名</span>
                    <span class="cont"><input type="text" v-model="user.realName" placeholder="输入姓名"></span>
                </div>
                <span class="btn">保存</span>
            </div> -->
            <div class="title">账号安全</div>

            <el-form :model="ruleForm" label-position="left" :rules="rules" ref="ruleForm" label-width="100px" class="ruleForm">
                <div v-if="!showPwd">
                    <el-form-item label="密码" prop="">
                        <span>******</span><span class="btn" @click="showPwd=!showPwd">修改密码</span>
                    </el-form-item>
                </div>
                <div v-else>
                    <el-form-item label="旧密码" prop="oldPsw">
                        <el-input type="password" v-model="ruleForm.oldPsw" placeholder="输入旧密码"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码" prop="pass">
                        <el-input type="password" v-model="ruleForm.pass" placeholder="输入新密码"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="newPsw">
                        <el-input  type="password" v-model="ruleForm.newPsw"  placeholder="再次输入新密码"></el-input><span class="btn" @click="submitForm('ruleForm')">保存</span>
                    </el-form-item>
                </div>
            </el-form>
            <!-- <div class="item">
                <div class="felx">
                    <span class="uname">旧密码</span>
                    <span class="cont"><input type="text" v-model="uname" placeholder="输入旧密码"></span>
                </div>
            </div>
            <div class="item">
                <div class="felx">
                    <span class="uname">新密码</span>
                    <span class="cont"><input type="text" v-model="uname" placeholder="输入新密码"></span>
                </div>
            </div>
            <div class="item">
                <div class="felx">
                    <span class="uname">确认密码</span>
                    <span class="cont"><input type="text" v-model="uname" placeholder="再次输入新密码"></span>
                </div>
                <span class="btn">保存</span>
            </div> -->
            <!-- <div class="item">
                <div class="felx">
                    <span class="uname">手机</span>
                    <span class="cont"><input type="text" v-model="user.tel" placeholder="输入手机"></span>
                </div>
                <span class="btn">保存</span>
            </div> -->
            
            <el-form :model="ruleFormTel" label-position="left" :rules="rules" ref="ruleFormTel" label-width="100px" class="ruleForm">
                <el-form-item label="手机" prop="tel">
                    <span class="back" v-if="!showTel">已绑定：+{{ruleFormTel.tel}}</span>
                    <el-input type="text" v-model="ruleFormTel.tel" placeholder="输入手机" v-else></el-input>
                    <!-- <el-input type="text" v-model="ruleFormTel.tel" placeholder="输入手机" ></el-input> -->
                    <span class="btn" @click="showTel=!showTel" v-if="!showTel">更换手机</span>
                    <span class="btn" @click="submitFormTel('ruleFormTel')" v-else>保存</span>
                </el-form-item>
            </el-form>

            <!-- <div class="item">
                <div class="felx">
                    <span class="uname">微信</span>
                    <span class="cont"><input type="text" v-model="uname" placeholder="输入手机"></span>
                </div>
                <span class="btn">保存</span>
            </div> -->
            <div class="edit"><span @click="Logout">退出登录</span></div>
    </div>
</template>

<script>
    import { UPDATE_AVATAR } from "../../api/upload";
    import { play } from "../../api/login";
    import { userList,userAccess,userUpdatedepsw,userDelete,userUpdate,projectUpdate,userAdd} from "../../api/center";
    import { userAllgroup } from '../../api/power.js'
	export default {
		name: "",
		data() {
            var checkAge = (rule, value, callback) => {
                if (value === "") {
                    return callback(new Error("密码不能为空"));
                } else {
                    if (this.ruleForm.oldPsw.length < 6 || this.ruleForm.oldPsw.length > 18) {
                        callback(new Error("要求6-18位字符"));
                    }
                    if (this.ruleForm.oldPsw.match(/([\u4E00-\u9FA5])+/)) {
                        callback(new Error("不能包含中文字符"));
                    }
                    callback();
                }
            };
            var validatePass = (rule, value, callback) => {
                var lts = /^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?![\W_]+$)\S{6,18}$/;
                if (value === "") {
                    callback(new Error("密码不能为空"));
                } else {
                    if (this.ruleForm.pass.length < 6 || this.ruleForm.pass.length > 18) {
                    callback(new Error("要求6-18位字符"));
                    }
                    if (this.ruleForm.pass.match(/([\u4E00-\u9FA5])+/)) {
                    callback(new Error("不能包含中文字符"));
                    }
                    if (value == this.ruleForm.oldPsw) {
                    callback(new Error("新密码与旧密码一致!"));
                    }
                    // if (!lts.test(value)) {
                    // callback(new Error("必须包含数字，字母，特殊符号两种或以上！"));
                    // }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === "") {
                    callback(new Error("请再次输入密码"));
                } else if (value !== this.ruleForm.pass) {
                    callback(new Error("两次输入密码不一致!"));
                } else {
                    callback();
                }
            };
            var checkPhone = (rule, value, callback) => {
                var phoneReg = /^((13[0-9])|(14[5-9])|(15([0-3]|[5-9]))|(16[6-7])|(17[1-8])|(18[0-9])|(19[1|3])|(19[5|6])|(19[8|9]))\d{8}$/
                if (value === '') {
                    callback(new Error('请输入手机号'));
                } else {
                    if (!phoneReg.test(value)) {
                        callback(new Error('输入格式错误'));
                    }else{
                        callback();
                    }
                    callback();
                }
            };
			return {
				imageUrl:"",
                ruleForm: {
                    pass: '',
                    newPsw: '',
                    oldPsw: ''
                },
                rules: {
                    oldPsw: [
                        { required: true, message: '请输入旧密码', trigger: 'blur' },
                        { validator: checkAge, trigger: 'blur' }
                    ],
                    pass: [
                        { validator: validatePass, trigger: 'blur' }
                    ],
                    newPsw: [
                        { validator: validatePass2, trigger: 'blur' }
                    ],
                    tel: [
                        { required: true, message: '请输入手机', trigger: 'blur' },
                        { validator: checkPhone, trigger: 'blur' }
                    ],
                    realName: [
                        { required: true, message: '请输入姓名', trigger: 'blur' },
                    ],
                    projectName: [
                        { required: true, message: '请输入项目名称', trigger: 'blur' },
                    ],
                    projectArea: [
                        { required: true, message: '请输入辖区面积', trigger: 'blur' },
                    ],
                    projectAddress: [
                        { required: true, message: '请输入园区地址', trigger: 'blur' },
                    ],
                    projectPowerOrigin: [
                        { required: true, message: '请输入供电来源', trigger: 'blur' },
                    ],
                },
                ruleFormName: {
                    realName: "",
                },
                ruleFormTel: {
                    tel: "",
                },
                showName:false,
                showPwd:false,
                showTel:false,
			}
		},
		components:{
            
		},
		computed:{
			user(){
                return this.$store.state.homeitem.user
            },
		},
		watch:{
			
		},
		mounted() {
			this.ruleFormName.realName = this.user.realName;
			this.ruleFormTel.tel = this.user.tel;
		},
		methods: {
            //退出登录
            Logout(){
                this.$router.push("/login");
                window.location.reload();
                window.sessionStorage.clear();
            },
            //修改手机
            submitFormTel(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let obj = {
                            uid:this.user.uid,
                            realName:"",
                            tel:this.ruleFormTel.tel,
                        }
                        play.userUpdate(obj).then((res) => {
                            if (res.data.status) {
                                this.$store.state.homeitem.user.tel = this.ruleFormTel.tel;
                                this.$message.success('恭喜你，手机修改成功！');
                                this.showTel = false
                            } else {
                                this.$message.error(res.data.errMsg);
                            }
                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                    });
            },
            //修改姓名
            submitFormName(formName) {
                this.$refs[formName].validate((valid) => {
                if (valid) {
                    let obj = {
                        uid:this.user.uid,
                        realName:this.ruleFormName.realName,
                        tel:"",
                    }
                    play.userUpdate(obj).then((res) => {
                        if (res.data.status) {
                            this.$store.state.homeitem.user.realName = this.ruleFormName.realName;
                            this.$message.success('恭喜你，姓名修改成功！');
                            this.showName = false
                            this.$emit("uploadName",true)
                        } else {
                            this.$message.error(res.data.errMsg);
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
                });
            },
            //修改密码
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                if (valid) {
                    play.loginpass(this.ruleForm.newPsw, this.ruleForm.oldPsw).then((res) => {
                        if (res.data.status) {
                            this.ruleForm.pass = "";
                            this.ruleForm.newPsw = "";
                            this.ruleForm.oldPsw = "";
                            this.$message.success('恭喜你，密码修改成功！');
                            this.showPwd = false
                        } else {
                            this.$message.error(res.data.errMsg);
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
                });
            },
			  //logo上传
            beforeAvatarUpload(file) {
                const isJPG = file.type === "image/jpeg";
                const isLt2M = file.size / 1024 / 1024 < 2;
                const isPNG = file.type === "image/png";

                if (!isJPG && !isPNG) {
                    this.$message.error("上传头像图片只能是 JPG和PNG 格式!");
                    return false;
                }
                if (!isLt2M) {
                    this.$message.error("上传头像图片大小不能超过 2MB!");
                    return false;
                }
                UPDATE_AVATAR(file).then((res) => {
                    // console.log(res);
                    this.imageUrl = res.data.data.path;
                    if (res.data.status) {
                        this.$store.state.homeitem.user.img = res.data.data.path;
                    }
                });

                return false;
                // return isJPG && isLt2M;
            }, 
		},
	}
</script>
<style lang="less" scoped>

/deep/.el-form-item__label:before{
    content: none !important;
}
/deep/ .ruleForm{
    .back{
        // height: 34rem;
        // line-height: 34rem;
        background: #01AB65;
        border-radius: 4rem;
        color: #ffffff;
        padding: 7rem 12rem;
    }
    .el-form-item__label{
        font-size: 18rem;
        font-weight: bold;
        color: #333333;
    }
    
    .el-input__inner{
        height: 36px;
        color: #333333;
    }
    .el-form-item{
        margin: 22rem 0
    }
    .el-input{
        width: 160rem;
    }
    .btn{
        float: right;
        width: 116rem;
        height: 36rem;
        line-height: 36rem;
        background: #FFFFFF;
        border: 1px solid #E5E5E5;
        border-radius: 18rem;
        text-align: center;
        color: #0D94FF;
        font-size: 18rem;
        cursor: pointer;
        vertical-align: middle;
    }
}

.base{
    // .w(592);
    // height:100%;
    // box-shadow: 0px 1px 8px 0px rgba(17,40,76,0.16);
    // border-radius: 8px;
    // background:url('../../assets/img/bg.png') top no-repeat #FFFFFF;
    // margin-right: 10px;
    // padding:0 24rem;
    // position: relative;
    .name{
        font-size: 36rem;
        font-weight: bold;
        color: #0D94FF;
        margin-top: 40rem;
        span{
            // .w(400);
            // max-width: 420rem;
            max-width:70%;
            display: inline-block;
            float: left;
            margin-right: 10px;
        }
        img{
            height: 28rem;
        }
    }
    .happy{
        font-size: 30rem;
        margin-top: 23rem;
    }
    .title{
        font-size: 18rem;
        font-weight: bold;
        border-bottom: 1px solid rgba(0, 0, 0, 0.15);
        padding-bottom: 8rem;
        margin-top: 50rem;
    }
    .title::before{
        content:"";
        border-left: 3px solid #0D94FF;
        padding-right: 10px;
        height: 18px;
        line-height: 18px;
    }
    .item{
        // height: 60px;
        margin: 22rem 0;
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
        align-items: center;
        .felx{
            
        }
        .uname{
            font-size: 18rem;
            font-weight: bold;
            width: 100px;
            display: inline-block;
        }
        .cont{
            display: inline-block;
            vertical-align: middle;
            img{
                width: 80rem;
                height: 80rem;
            }
            input{
                width: 160rem;
                height: 36px;
                background: #FFFFFF;
                border: 1px solid #E5E5E5;
                border-radius: 4px;
                padding: 0 10px;
            }
        }
        .btn{
            float: right;
            width: 116rem;
            height: 36rem;
            line-height: 36rem;
            background: #FFFFFF;
            border: 1px solid #E5E5E5;
            border-radius: 18rem;
            text-align: center;
            color: #0D94FF;
            font-size: 18rem;
            cursor: pointer;
            vertical-align: middle;
        }
    }
    
    .edit{
        text-align: center;
        // margin-top: 60rem;
        position: absolute;
        bottom:50px;
        left: 0;
        width:100%;
        span{
            width: 400rem;
            height: 56rem;
            line-height: 56rem;
            background: #0D94FF;
            border-radius: 28rem;
            text-align: center;
            color: #ffffff;
            font-size: 18rem;
            font-weight: bold;
            cursor: pointer;
            display: inline-block;
        }
    }
}

</style>